import RegisterSuccessMentor from "./RegisterSuccessMentor";
export default RegisterSuccessMentor;
